import React, { useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { observer } from 'mobx-react';
import { TeamDTO, TeamToSAVE, TournamentDTO } from 'screens/liveScoring/DTO';
import { stores } from 'mobx-store';
import ImageUploader from 'screens/liveScoring/components/uploadLogo';
import { makeStyles } from '@material-ui/core/styles';

interface TeamFormProps {
  open: boolean;
  onClose: () => void;
  team: TeamDTO | null;
}

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: '100%',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
}));

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  nameShort: Yup.string().required('Short Name is required'),
  logo: Yup.string().nullable(),
  tournamentIds: Yup.array().of(Yup.number()).required('At least one tournament is required').min(1, 'At least one tournament is required'),
});

const TeamForm: React.FC<TeamFormProps> = observer(
  ({ open, onClose, team }) => {
    const classes = useStyles();
    const { liveScoringStore } = stores;

    const handleSubmit = async (values: any) => {
      try {
        const teamToSave: TeamToSAVE = {
          name: values.name,
          nameShort: values.nameShort,
          logo: values.logo,
          tournamentIds: values.tournamentIds,
        };
        console.log('fdjfdfd', teamToSave)

        if (team?.id) {
          await liveScoringStore.updateTeam(team.id, teamToSave);
        } else {
          await liveScoringStore.createTeam(teamToSave);
        }
        onClose();
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    };

    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>{team ? 'Edit Team' : 'Add New Team'}</DialogTitle>
        <Formik
          initialValues={{
            name: team?.name || '',
            nameShort: team?.nameShort || '',
            logo: team?.logo || '',
            tournamentIds: team?.tournaments.map(t => t.id) || [],
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, isSubmitting, values, setFieldValue }) => (
            <Form>
              <DialogContent>
                <Field
                  as={TextField}
                  name="name"
                  label="Name"
                  fullWidth
                  margin="normal"
                  error={touched.name && !!errors.name}
                  helperText={touched.name && errors.name}
                />
                <Field
                  as={TextField}
                  name="nameShort"
                  label="Short Name"
                  fullWidth
                  margin="normal"
                  error={touched.nameShort && !!errors.nameShort}
                  helperText={touched.nameShort && errors.nameShort}
                />
                <ImageUploader
                  name="logo"
                  label="Logo"
                  setFieldValue={setFieldValue}
                  logoUrl={values.logo}
                />

                <FormControl className={classes.formControl} error={touched.tournamentIds && !!errors.tournamentIds}>
                  <InputLabel id="tournaments-label">tournaments</InputLabel>
                  <Select
                    labelId="tournaments-label"
                    multiple
                    name="tournamentIds"
                    value={values.tournamentIds}
                    onChange={(e) => setFieldValue('tournamentIds', e.target.value)}
                    renderValue={(selected) => (selected as number[]).map(id => liveScoringStore.tournaments.find(t => t.id === id)?.name).join(', ')}
                  >
                    {liveScoringStore.tournaments.map((tournament) => (
                      <MenuItem key={tournament.id} value={tournament.id}>
                        {tournament.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="secondary">
                  Cancel
                </Button>
                <Button type="submit" color="primary" disabled={isSubmitting}>
                  {isSubmitting ? 'Saving...' : 'Save'}
                </Button>

              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    );
  }
);

export default TeamForm;